<template>
  {{ field.name }}
  <Editor
    v-model="localValue"
    :init="{
      base_url: '/tinymce',
      suffix: '.min',
      plugins: 'lists link image table code',
      toolbar:
        'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
      skin: 'oxide',
      content_css: 'default',
    }"
    :hint="field.description"
    :rules="fieldRules"
    licenseKey="gpl"></Editor>
  :hint="field.description" :rules="fieldRules" />
</template>

<script setup lang="ts">
import { IRubricFieldDTO } from '@/dtos';
import Editor from '@tinymce/tinymce-vue';
import { rules } from '@/helpers';

import { ref, computed, watch } from 'vue';

import '@/components/tinymce/tinymce';

const props = defineProps<{
  field: IRubricFieldDTO;
  modelValue?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', fieldId: string, value: string): void;
}>();

const field = props.field;

const fieldRules = ref<((value: string) => true | string)[]>([]);
watch(
  () => field,
  () => {
    fieldRules.value = [];
    if (field.is_required) {
      fieldRules.value.push(rules.required);
    }
  },
  { immediate: true },
);

const localValue = computed({
  get: () => props.modelValue ?? '',
  set: (val: string) => emit('update:modelValue', field.id, val ?? ''),
});
</script>
